import Fnc from './library/Functions';

export const Config = {
  envs: [
    {
      "type": "LOCAL",
      "domain": "https://uat-www.italiaonline.it",
      "apiPath": "https://forlocalhost.italiaonline.it/services_v1",
      "bypassCaptchaToken": "",
      "apiLbsPath": "https://services.tuttocitta.it/lbs",
      "areaClientiPath": "https://test-portaleclienti.italiaonline.it/",
      "areaClientiSDIYFPath": "https://test-portaleclienti.italiaonline.it/contratto/#commissioneaddOn#/gestisci-prodotti/sito/wizard",
      "areaClientiCMFTFPath": "https://test-portaleclienti.italiaonline.it/contratto/#commissioneaddOn#/gestisci-prodotti/multichannel/nuova-campagna",
      "logsLevel": Fnc.LogLvl.DEBUG,
      "businessHome": "/",
      "basketHome": "/carrello",
      "registrationEnd": "/carrello/registrazione/end",
      "registrationSito": "/carrello/registrazione/sito",
      "registrationCampagna": "/carrello/registrazione/campagna",
      "gaMeasurementId": "G-PZNSHBKJ0M",
      "gaEnv": "dev",
      "courtesyPage" : "/manutenzione/"
    },
    {
      "type": "UAT",
      "domain": "https://uat-www.italiaonline.it",
      "apiPath": "/services_v1",
      "bypassCaptchaToken": "",
      "apiLbsPath": "https://services.tuttocitta.it/lbs",
      "areaClientiPath": "https://test-portaleclienti.italiaonline.it/",
      "areaClientiSDIYFPath": "https://test-portaleclienti.italiaonline.it/contratto/#commissioneaddOn#/gestisci-prodotti/sito/wizard",
      "areaClientiCMFTFPath": "https://test-portaleclienti.italiaonline.it/contratto/#commissioneaddOn#/gestisci-prodotti/multichannel/nuova-campagna",
      "logsLevel": Fnc.LogLvl.DEBUG,
      "businessHome": "/",
      "basketHome": "/carrello",
      "registrationEnd": "/carrello/registrazione/end",
      "registrationSito": "/carrello/registrazione/sito",
      "registrationCampagna": "/carrello/registrazione/campagna",
      "gaMeasurementId": "G-PZNSHBKJ0M",
      "gaEnv": "test",
      "courtesyPage" : "/manutenzione/"
    },
    {
      "type": "PRODUCTION",
      "domain": "https://www.italiaonline.it",
      "apiPath": "/services_v1",
      "bypassCaptchaToken": "",
      "apiLbsPath": "https://services.tuttocitta.it/lbs",
      "areaClientiPath": "https://areaclienti.italiaonline.it/",
      "areaClientiSDIYFPath": "https://areaclienti.italiaonline.it/contratto/#commissioneaddOn#/gestisci-prodotti/sito/wizard",
      "areaClientiCMFTFPath": "https://areaclienti.italiaonline.it/contratto/#commissioneaddOn#/gestisci-prodotti/multichannel/nuova-campagna",
      "logsLevel": Fnc.LogLvl.DEBUG,
      "businessHome": "/",
      "basketHome": "/carrello",
      "registrationEnd": "/carrello/registrazione/end",
      "registrationSito": "/carrello/registrazione/sito",
      "registrationCampagna": "/carrello/registrazione/campagna",
      "gaMeasurementId": "G-PZNSHBKJ0M",
      "gaEnv": "online",
      "courtesyPage" : "/manutenzione/"
    }
  ],
  stepList: [
    { "idx": -1, "path": "/carrello/err", "re": "^/carrello/err$", "desc": "Errore", "default": false, "enabled": false, "withBasket": false, bskType: Fnc.BasketType.BOTH, "gaCheckoutStep": -1, "basketTitle" : "Completa il tuo acquisto" },
    { "idx": -2, "path": "/carrello/empty", "re": "^/carrello/empty$", "desc": "Carrello Vuoto", "default": false, "enabled": false, "withBasket": false, bskType: Fnc.BasketType.BOTH, "gaCheckoutStep": -1, "basketTitle" : "Completa il tuo acquisto" },
    { "idx": 9, "path": "/carrello/fill", "re": "^/carrello/fill$", "desc": "Personalizzazione", "default": false, "enabled": false, "withBasket": true, bskType: Fnc.BasketType.PAY, "gaCheckoutStep": -1, "basketTitle" : "Completa il tuo acquisto" },
    { "idx": 10, "path": "/carrello", "re": "^/carrello[/]?$", "desc": "Dati fatturazione", "descPrev": "Dati contatto", "default": true, "enabled": true, "withBasket": true, bskType: Fnc.BasketType.BOTH, "gaCheckoutStep": 1, "basketTitle" : "Completa il tuo acquisto" },
    { "idx": 11, "path": "/carrello/pay", "re": "^/carrello/pay$", "desc": "Dati Pagamento", "default": false, "enabled": true, "withBasket": true, bskType: Fnc.BasketType.PAY, "gaCheckoutStep": 2, "basketTitle" : "Completa il tuo acquisto" },
    { "idx": 12, "path": "/carrello/end", "re": "^/carrello/end$", "desc": "Riepilogo Finale", "descPrev": "Riepilogo Finale", "default": false, "enabled": true, "withBasket": false, bskType: Fnc.BasketType.BOTH, "gaCheckoutStep": 3, "basketTitle" : "Acquisto completato" }
  ],
  reCaptchaKey: "6LdgfboUAAAAADM14NWgB9xQ9M2U-Jp1eo-AThSm",
	version: "1.1.3"
};


